import { message, Upload } from "antd";
import type { RcFile } from "antd/es/upload";

export const ALLOWED_FILE_TYPES = [
  // Document Files
  ".doc",
  ".docx",
  ".odt",
  ".pdf",
  ".txt",
  ".rtf",
  // Spreadsheet Files
  ".xls",
  ".xlsx",
  ".xlsm",
  ".csv",
  // Presentation Files
  ".ppt",
  ".pptx",
  // Image Files
  ".jpg",
  ".jpeg",
  ".png",
  // Design & Creative Files
  ".psd",
  ".ai",
  ".svg",
  // Compressed Archives
  ".zip",
  ".rar",
  ".7z",
  // Project-Specific Files
  ".mpp",
  ".xd",
  ".xer",
  ".xml",
  // Emails
  ".msg",
  ".eml"
];
export const ALLOWED_FILE_TYPES_STRING = ALLOWED_FILE_TYPES.join(",");

export const validateFileType = (file: RcFile): boolean | string => {
  const fileName = file.name.toLowerCase();
  const fileExtension = fileName.substring(fileName.lastIndexOf("."));

  if (!ALLOWED_FILE_TYPES.includes(fileExtension)) {
    message.error("We do not support this file format.");
    return Upload.LIST_IGNORE;
  }
  return true;
};
